import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/atc/ATC CREAM strawberry.png";
import BiscuitImg from "../../../assets/products/atc/ATC-Strawberry.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 125,
  },
  {
    grams: 150,
  },
];

export default function StrawberryATCProduct() {
  return (
    <>
      <Helmet>
        <title>
          ATC Strawberry Cream Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz ATC Strawberry Cream Biscuits — sweet strawberry-flavored cream biscuits in ATC format. View pack sizes and global specifications."
        />
        <meta
          name="keywords"
          content="ATC Strawberry Cream Biscuit, BearBitz ATC Strawberry"
        />
        <link rel="canonical" href="https://www.bearbitz.in/atc/strawberry" />
        <meta
          property="og:title"
          content="ATC Strawberry Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Strawberry cream biscuit in ATC format with export-ready packaging and premium taste."
        />
      </Helmet>

      <ProductTemplate
        productTitle="STRAWBERRY"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in The rich taste of ATC Cream Biscuits, where every crunchy bite meets a smooth and creamy filling."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#FF009F"
        sectionBgColor="#FFDBF4"
        productBgcolor="#FFADE6"
        tableheadBgcolor="#FF009F"
        tableBgcolor="#FFEEFA"
        footerBgcolor="#FF009F"
      />
    </>
  );
}
